"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLinearClaimerContract = void 0;
var hooks_1 = require("../shared/hooks");
var _abi_1 = require("../abi");
var useContract_1 = require("../contracts/useContract");
function useLinearClaimerContract(address, version) {
    if (version === void 0) { version = 'v1'; }
    var targetChainWeb3 = (0, hooks_1.useWeb3Provider)().targetChainWeb3;
    return (0, useContract_1.useContract)(_abi_1.CONTRACTS.linearClaimer[version].abi, address, targetChainWeb3);
}
exports.useLinearClaimerContract = useLinearClaimerContract;
